import ctl from '@netlify/classnames-template-literals'
import { ReactNode } from 'react'
import { Tooltip } from '../../tooltip'

export interface WidgetMicroButtonProps {
	children?: ReactNode
	onClick: () => void
	disabled?: boolean
	pressed?: boolean
	title?: string
	variant?: 'default' | 'naked'
}

export function WidgetMicroButton(
	{
		children,
		onClick,
		disabled = false,
		pressed,
		title,
		variant = 'default',
	}: WidgetMicroButtonProps,
) {
	const button = (
		<div className="grid place-items-center">
			<button
				type="button"
				className={ctl(`
					text-sm text-left
					grid place-items-center
					${
					variant === 'naked'
						? `rounded p-0.5 ${
							pressed ? 'bg-blue-50 text-blue-600' : 'text-grey-400 hover:bg-grey-100 hover:text-grey-600'
						}`
						: `rounded-full shadow-sm p-1 ${
							pressed
								? 'bg-blue-100 text-blue-600 ring ring-blue-300'
								: 'bg-white text-grey-600 ring ring-grey-200'
						}`
				}
					${disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'}
				`)}
				onClick={onClick}
				disabled={disabled}
				aria-pressed={pressed}
			>
				{children}
			</button>
		</div>
	)

	if (title) {
		return <Tooltip content={title}>{button}</Tooltip>
	}

	return button
}
